module.exports = __webpack_public_path__ + "img/pragmatic.5a358955.png";